import React from 'react';
import { Loader, BaasicTable } from 'core/components';
import { defaultTemplate } from 'core/hoc';

const BulkPrintHistoryTemplate = ({ t, viewStore, viewStore: { listStore, tableData, queryUtility, loading } }) => {
	if (loading) return <Loader />;
	return (
		<React.Fragment>
			<div className="layout__main__subheader">
				<h2 className="layout__main__subheader__title">{t('FULFILLMENTORDER.BULKPRINT.HISTORY')}</h2>
			</div>
			<BaasicTable actions={viewStore} data={listStore.data.slice()} {...{ tableData, queryUtility, viewStore }} />
		</React.Fragment>
	);
};

export default defaultTemplate(BulkPrintHistoryTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/BulkPrintHistoryTemplate.jsx